import React from 'react';

const PHONE_RE = /(\(?859\)?[\s.-]?357[\s.-]?6803)/g;
const TEL = 'tel:8593576803';
const LINK_CLS = 'font-semibold text-emerald-700 underline decoration-emerald-300 underline-offset-2 hover:decoration-emerald-700 whitespace-nowrap';

// Renders text with every ComfortMaster phone number as a tappable (tracked) tel: link
export const PhoneLinkText = ({ text }) => {
  if (!text) return null;
  return String(text).split(PHONE_RE).map((part, i) =>
    i % 2 === 1
      ? <a key={i} href={TEL} className={LINK_CLS} data-testid="inline-phone-link">{part}</a>
      : <React.Fragment key={i}>{part}</React.Fragment>
  );
};

// Same for HTML strings (blog bodies); numbers already inside links or tags are left alone
export const linkifyPhoneHtml = (html) =>
  String(html || '')
    .split(/(<a\b[^>]*>[\s\S]*?<\/a>|<[^>]+>)/i)
    .map((part) => (part.startsWith('<') ? part : part.replace(PHONE_RE, `<a href="${TEL}" class="${LINK_CLS}" data-testid="inline-phone-link">$1</a>`)))
    .join('');
